// Myworkspace.js
// Purpose: Displays a list of workspaces the user belongs to and manages workspace-related actions.
// Logic: Uses React hooks and APIs to fetch workspace data, handle navigation, and manage modal popups for workspace actions.

import React, { useEffect, useState } from "react";
import useCommonApi from "../hooks/common-apis";
import useCommonFunctions from "../hooks/common-functions";
import { useNavigate } from "react-router-dom";
import PopupModals from "../components/PopupModals";
import { clog, getEncriptedLoginData } from "../lib/utils";
import Avatar from "../components/Avatar";
function Myworkspace() {
  const { getWorkspaces } = useCommonApi();
  const { getLetters, getBackgroundColor, checkWorkspaceEnabled } =
    useCommonFunctions();
  const navigate = useNavigate();
  const [workspaceList, setworkspaceList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setshowModal] = useState({
    first: false,
    second: false,
    third: false,
  });
  const [popupMessage, setpopupMessage] = useState("");
  const getWorkspaceGraphql = async () => {
    setLoading(true);
    try {
      let workspaces = await getWorkspaces();
      // clog(workspaces,"works")
      // Handle the response data as needed
      setworkspaceList(workspaces || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getWorkspaceGraphql();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Function to handle workspace switching with user_menus and plan_id update
  const handleWorkspaceSwitch = (workspace) => {
    // Update selected_workspace in localStorage
    localStorage.setItem("selected_workspace", JSON.stringify(workspace));

    // Update workspace_id, user_menus, and plan_id in login_data
    let login_data = JSON.parse(localStorage.getItem("login_data") || "{}");
    if (login_data && login_data.resp_user) {
      login_data.resp_user.workspace_id = workspace?.workspace_id;

      // Update plan_id from workspace owner's plan
      // if (workspace?.user?.plan_id) {
      //   login_data.resp_user.plan_id = workspace.user.plan_id;
      // }

      // Update user_menus with encryption if available in workspace
      if (workspace?.user_menus) {
        // Create a copy with the new user_menus (unencrypted)
        const updatedLoginData = {
          ...login_data,
          user_menus: workspace.user_menus,
        };

        // Encrypt and save to localStorage
        const encryptedData = getEncriptedLoginData(updatedLoginData);
        localStorage.setItem("login_data", JSON.stringify(encryptedData));
      } else {
        // If no user_menus in workspace, just save without updating menus
        localStorage.setItem("login_data", JSON.stringify(login_data));
      }
    }

    // Navigate to script page
    navigate("/script");
  };

  return (
    <>
      <h6 className="font-bold text-[24px] mb-8">My Workspaces</h6>

      <div className="w-full">
        <div className="flex flex-wrap -mx-6 mb-6">
          {loading && workspaceList.length === 0
            ? [...Array(6)].map((_, index) => (
                <div
                  key={index}
                  className="w-full md:w-1/6 px-6 mb-6 md:mb-0 flex justify-center"
                >
                  <div className="text-center">
                    <div className="flex justify-center">
                      <div className="w-[50px] h-[50px] rounded-full bg-gray-300 skeleton-wave"></div>
                    </div>
                    <div className="pt-4">
                      <div className="h-4 w-32 bg-gray-300 rounded skeleton-wave mx-auto"></div>
                    </div>
                  </div>
                </div>
              ))
            : workspaceList?.map((workspace, index) => (
                <div
                  key={workspace?.workspace_id || index}
                  className="w-full md:w-1/6 px-6 mb-6 md:mb-0"
                >
                  <button
                    type="button"
                    className="text-center hover:text-[#1D70A6]"
                    onClick={() => handleWorkspaceSwitch(workspace)}
                  >
                    <div className="flex justify-center">
                      <button
                        type="button"
                        className="flex items-center hover:text-[#1A71A7]"
                      >
                        <Avatar
                          type="workspace"
                          data={workspace}
                          size="50px"
                          fontSize="20px"
                        />
                      </button>
                    </div>
                    <p className="pt-4">
                      {workspace?.workspace?.workspace_name}'s workspace
                    </p>
                  </button>
                </div>
              ))}
        </div>
      </div>

      {/* <div className="flex justify-center">
        <button
          type="button"
          className="flex items-center p-[10px] rounded-full bg-[#EEF5FF] font-semibold text-[22px] hover:bg-[#dde4ed] transition duration-700"
          onClick={() => {
            if (!checkWorkspaceEnabled()) {
              setpopupMessage("Add New Workspace");
              setshowModal({
                first: false,
                second: true,
                third: false,
              });
              return;
            } else {
              navigate("/add-workspace");
            }
          }}
        >
          <div className="flex items-center justify-center rounded-[25px] w-[50px] h-[50px] text-[#fff] bg-gradient-to-r from-[#097BA9] to-[#9B3785] me-3">
            <svg className="icon">
              <use href="#icon_plus"></use>
            </svg>
          </div>
          Add New Workspace
        </button>
      </div> */}
      <PopupModals
        showModal={showModal}
        setshowModal={setshowModal}
        popupMessage={popupMessage}
      />
    </>
  );
}

export default Myworkspace;
